const v = window.big5Vendor;
if (!v) {
  throw new Error('Load assets/js/vendor.js before main.js');
}

export const gsap = v.gsap;
export const ScrollTrigger = v.ScrollTrigger;
export const Swiper = v.Swiper;
export const GLightbox = v.GLightbox;
export default v.Lenis;
